import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RefreshTokenServicePathConst } from '../../app-config.const';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		if (!request || !request.url) {
			return next.handle(request);
		}

		const token = localStorage.getItem('superAppsBack.accessToken');

		if (!!token) {
			const headers: Record<string, string> = {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			};

			if (request.url !== RefreshTokenServicePathConst) {
				headers.Authorization = `Bearer ${token}`;
			}

			if (request.body) {
				if (request.body instanceof FormData) {
					delete headers['Content-Type'];
				}
			}

			request = request.clone({
				setHeaders: headers,
			});
		}

		return next.handle(request);
	}
}
